import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config/config";

export const fetchCollections = createAsyncThunk(
  "collections/fetchCollections",
  async (_, { rejectWithValue }) => {
    try {
      let search = [];
      search.push("best women dress");
      search.push("Shirts");
      search.push("winter jackets & hoodies");
      search.push("Shoes Slide");
      search.push("Perfumes");
      search.push("Watches");

      const response = await axios.get(
        `${config.backendUrl}/inventory/batch_search`,
        {
          params: { q: search },
        }
      );

      return response.data?.results?.responses || [];
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch collections"
      );
    }
  }
);

const initialState = {
  collections: [],
  loading: false,
  error: null,
};

const collectionsSlice = createSlice({
  name: "collections",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCollections: (state) => {
      state.collections = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.collections = action.payload;
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearCollections } = collectionsSlice.actions;
export default collectionsSlice.reducer;
